import { FC } from 'react'
import { GridCellProps } from '@progress/kendo-react-grid'
import { ClientSubscriptionDetailBackOfficeDto } from 'api/Trading-Accounts/Types/ClientSubscriptionDetailBackOfficeDto'
import { formatLocalDateUTC } from 'utils/date'

import { SubscriptionRequestState } from './SubscriptionRequestState'
import { SubscriptionRequestTypeEnum } from './SubscriptionRequestTypeEnum'
import { SubscriptionTimeInForce } from './SubscriptionTimeInForce'

const SINGLE_LEVEL_ID = 3

export const SubscriptionStatusMessage: FC<GridCellProps> = (props) => {
  return <td>{getMessage(props)}</td>
}

const getMessage = (props: GridCellProps): string => {
  if (isEmptyMessage(props)) {
    return ''
  }

  if (isCancelMessage(props)) {
    return getCancelMessage(props)
  }

  if (isValidFromMessage(props)) {
    return getValidFromMessage(props)
  }

  if (isUpdateOrNewMessage(props)) {
    return getUpdateOrNewMessage(props)
  }

  return ''
}

const isEmptyMessage = (props: GridCellProps) => {
  const { dataItem } = props

  return !dataItem?.subscriptionRequest || !dataItem.subscriptionRequest?.state
}

const isCancelMessage = (props: GridCellProps) => {
  const { dataItem } = props
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto
  const { type, state } = subscriptionRequest!

  return (
    state.id === SubscriptionRequestState.Pending &&
    type.id === SubscriptionRequestTypeEnum.CancelExistingSubscription
  )
}

const isValidFromMessage = (props: GridCellProps) => {
  const { dataItem } = props
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto
  const { type, state } = subscriptionRequest!

  return (
    state.id === SubscriptionRequestState.Pending &&
    type.id === SubscriptionRequestTypeEnum.UpdateExistingSubscription
  )
}

const isUpdateOrNewMessage = (props: GridCellProps) => {
  const { dataItem } = props
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto
  const { type } = subscriptionRequest!

  return (
    type.id === SubscriptionRequestTypeEnum.AddNewSubscription &&
    subscriptionRequest?.subscriptionTimeInForce?.id ===
      SubscriptionTimeInForce.BeginningOfNextMonth
  )
}

const getCancelMessage = (props: GridCellProps): string => {
  const { dataItem } = props
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto

  return `Active until ${formatLocalDateUTC(subscriptionRequest?.dueDate)}`
}

const getValidFromMessage = (props: GridCellProps): string => {
  const { dataItem } = props
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto

  return `Valid from ${formatLocalDateUTC(subscriptionRequest?.dueDate)}`
}

const getUpdateOrNewMessage = (props: GridCellProps): string => {
  const { dataItem } = props
  const { id, name } = dataItem.level
  const { subscriptionRequest } = dataItem as ClientSubscriptionDetailBackOfficeDto
  const levelName = id < SINGLE_LEVEL_ID ? name : ''

  return `${levelName} starting on ${formatLocalDateUTC(subscriptionRequest?.dueDate)}`
}
